module.exports = __webpack_public_path__ + "img/hzh.a87bbbea.jpg";